module.exports = __webpack_public_path__ + "img/13.063009a2.svg";